export class CurrentTransformer {
  number_of_transformers_needed: number;
  size_of_transformer: string;
}
